import React, { useEffect } from "react";
import SideMenu from "./sideMenu";
import { Outlet } from "react-router-dom";
import { Navbar } from "./navbar";
import { Colors } from "../Constants/colors";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser } from "../Redux/Slices/user.slice";
import { AppDispatch, RootState } from "../Redux/store";
import deco from "./../images/header-deco.svg";
import { SwipeableDrawer } from "@mui/material";
import { setShowSideMenuBar } from "../Redux/Slices/sideMenu.slice";
import { useMobile } from "../hooks/deviceHooks/useDevice.hooks";
import { useSocket } from "../hooks/socketHooks/socket.hooks";

const AppWrapper = () => {
  const dispatch: AppDispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");
  const isMobile = useMobile();

  const sideMenuBar = useSelector((state: RootState) => ({
    hideSideMenuBar: state.sideMenu.hideSideMenuBar,
  }));

  useSocket();

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchUser());
    }
  }, [accessToken, dispatch]);

  if (!accessToken) {
    window.location.replace("/login");
    return <></>;
  }

  return (
    <div
      className="flex lg:flex-row w-full"
      style={{
        height: "100vh",
      }}
    >
      {isMobile ? (
        <SwipeableDrawer
          open={sideMenuBar.hideSideMenuBar}
          anchor="left"
          onClose={() => {
            dispatch(setShowSideMenuBar(false));
          }}
          onOpen={() => {
            dispatch(setShowSideMenuBar(true));
          }}
        >
          <div
            // className="w-1/5"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              bottom: 0,
              zIndex: 1000,
            }}
          >
            <SideMenu />
          </div>
        </SwipeableDrawer>
      ) : (
        <div
          className="w-1/5"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            zIndex: 1000,
          }}
        >
          <SideMenu />
        </div>
      )}

      <div
        id="app-root"
        className="flex flex-col h-full w-full"
        style={{
          marginLeft: !isMobile ? "20%" : undefined,
          marginTop: "72px", //THIS IS EQUIVALENT OF THE NAVBAR
          backgroundColor: Colors.VeryLightGrey,
          zIndex: 999,
          position: "relative",
        }}
      >
        <Navbar />
        <div className="p-6 h-fit" style={{ height: "100%", width: "100%" }}>
          <div
            style={{
              position: "fixed",
              top: 72,
              right: 0,
              zIndex: -999,
              // width: isMobile ? "100px" : "300px",
              // height: isMobile ? "100px" : "300px",
              width: "300px",
              height: "300px",
            }}
          >
            <img src={deco} alt="decoratorIcon" /> {/*  Replace this image */}
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
export default AppWrapper;
